import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// The build is prerendered to static HTML (crawlers get full markup + SEO tags).
// On the client we render into the container: React's output is identical to the
// prerendered DOM, so the prerendered paint is shown instantly then seamlessly taken over.
ReactDOM.createRoot(container).render(tree);
